// # Content Reviewer routes configuration
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../ProtectedRoute';

// # Import content reviewer components
import ContentReviewerDashboard from '../../roles/employees/content_reviewer/cont_rev_dashboard';

// # Import shared components
import Profile from '../../general/profile/profile';
import Settings from '../../general/gen_pages/settings';

// # Content Reviewer routes component
const ContentReviewerRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={
        <ProtectedRoute requiredRole="content_reviewer">
          <ContentReviewerDashboard />
        </ProtectedRoute>
      } />
      <Route path="/profile" element={
        <ProtectedRoute requiredRole="content_reviewer">
          <Profile />
        </ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute requiredRole="content_reviewer">
          <Settings />
        </ProtectedRoute>
      } />
    </Routes>
  );
};

export default ContentReviewerRoutes; 